import React from 'react';
import { Container } from "react-bootstrap";

const Imprint = () => {

    return (
        <Container className="imprint-body">
            <h3>Imprint</h3>
            <h4>Publisher</h4>
            <p>Semantic Web Company GmbH (SWC).<br />
                Mariahilferstrasse 70 /&nbsp;Neubaugasse 1, Top 8<br />
                A-1070 Vienna,&nbsp;Austria<br />
                Phone: +43 1 402 12 35<br />
                Fax: +43 1 4021235-22<br />
                eMail: <a className="pp-link" href="mailto:office@semantic-web.at" rel="nofollow">office@semantic-web.at</a></p>
            <p>Commercial Court Number: 323939g<br />
                Commercial Court: Handelsgericht Wien<br />
                VAT number: ATU64867647</p>
            <p>
                <a className="pp-link" href="http://www.wkoecg.at/Web/Ecg.aspx?FirmaID=8c3e2b21-8963-4ddd-8b11-de8389fef4e7" rel="noopener noreferrer" target="_blank">
                    Official Information</a>&nbsp;about the company by the Austrian Federal Economic Chamber.</p>
            <h4>Disclaimer</h4>
            <p>The Semantic Web Company (SWC) maintains this website on a regular basis to keep the information timely and accurate.
            If errors are brought to our attention, we will try to correct them. However SWC accepts no responsibility or liability whatsoever with regard to the information gathered via <a className="pp-link" href="https://ner-demo.poolparty.biz" rel="noopener noreferrer" target="_blank">https://ner-demo.poolparty.biz</a> or any linked sites.
            </p>
            <p>
                It is our goal to minimize disruption caused by technical errors. However some data or information accessible via this website may have been created or structured in files or formats that are not error-free and we cannot guarantee that our service will not be interrupted or otherwise affected by such problems. SWC accepts no responsibility with regard to such problems incurred as a result of using <a className="pp-link" href="https://ner-demo.poolparty.biz" rel="noopener noreferrer" target="_blank">https://ner-demo.poolparty.biz</a> or any linked sites.
            </p>
            <p>This disclaimer is not intended to limit the liability of SWC in contravention of any requirements laid down in applicable national law nor to exclude its liability for matters which may not be excluded under that law.</p>
        </Container>
    )
};

export default Imprint;

